import {
  APP_SETTING_UPDATE_PAGE_SCRIPT_BEGIN,
  APP_SETTING_UPDATE_PAGE_SCRIPT_SUCCESS,
  APP_SETTING_UPDATE_PAGE_SCRIPT_FAILURE,
  APP_SETTING_UPDATE_PAGE_SCRIPT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updatePageScript(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_PAGE_SCRIPT_BEGIN,
    });
    const { projectId, version, pageId, customScript } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${pageId}`,
        { customScript },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_UPDATE_PAGE_SCRIPT_SUCCESS,
            data: res,
          });
          toast.success('Updated Successfully !', {});
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_PAGE_SCRIPT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdatePageScriptError() {
  return {
    type: APP_SETTING_UPDATE_PAGE_SCRIPT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_PAGE_SCRIPT_BEGIN:
      return {
        ...state,
        updatePageScriptPending: true,
        updatePageScriptError: null,
      };

    case APP_SETTING_UPDATE_PAGE_SCRIPT_SUCCESS:
      return {
        ...state,
        updatePageScriptPending: false,
        updatePageScriptError: null,
      };

    case APP_SETTING_UPDATE_PAGE_SCRIPT_FAILURE:
      return {
        ...state,
        updatePageScriptPending: false,
        updatePageScriptError: action.data.error,
      };

    case APP_SETTING_UPDATE_PAGE_SCRIPT_DISMISS_ERROR:
      return {
        ...state,
        updatePageScriptError: null,
      };

    default:
      return state;
  }
}
